import store from '@/store/store';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';

class EscalaController {
  public static async getDadosHorario(
    nrVinculo: string,
    date: string,
    showLoading: boolean = true,
    requestCode: number = null,
  ) {
    const route = 'getHorarioBaseDia';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRVINCULOM: nrVinculo,
      DATE: date,
    };

    const response = await HttpRequest.get(route, params, showLoading, requestCode);
    const horarioBase: any = response.data.dataset.data;

    return horarioBase;
  }

  public static async getTurnoParOuImpar(
    nrEscala: string,
    number: string | Number,
    date: string,
    showLoading: boolean = true,
    requestCode: number = null,
  ) {
    const route = 'getTurnoParOuImpar';

    const nrOrg = store.getters.user.nrorg;

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRESCALATRABM: nrEscala,
      NUMBER: number,
      DIAREFERENCIA: date,
    };

    const response = await HttpRequest.get(route, params, showLoading, requestCode);
    const turno: any = response.data.dataset.data;

    return turno;
  }
}

export default EscalaController;
